import { render } from "./ParticlesBackground.vue?vue&type=template&id=57558a80"
import script from "./ParticlesBackground.vue?vue&type=script&lang=js"
export * from "./ParticlesBackground.vue?vue&type=script&lang=js"

import "./ParticlesBackground.vue?vue&type=style&index=0&id=57558a80&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__